<template>
  <div id="content"></div>
</template>

<script>
import { defineComponent, ref, inject, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getFeishuUrl } from '@/services/user'

export default defineComponent({
  name: 'LoginQrCode',
  setup () {
    const toLogin = inject('toLogin')

    const createQrCode = async () => {
      const route = useRoute()
      const { query } = route
      if (query.token) {
        const token = JSON.parse(query.token)
        try {
          await toLogin(token)
        } catch (error) {
          console.log(error)
        }
      } else {
        try {
          const { data } = await getFeishuUrl(window.location.href)
          const goto = data
          const QRLoginObj = window.QRLogin({
            id: 'content',
            goto,
            width: '300',
            height: '300',
            style: 'border: none;'
          })

          const handleMessage = (event) => {
            const origin = event.origin
            // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
            if (QRLoginObj.matchOrigin(origin)) {
              const loginTmpCode = event.data
              // 在授权页面地址上拼接上参数 tmp_code，并跳转
              window.location.href = `${goto}&tmp_code=${loginTmpCode}`
            }
          }

          if (typeof window.addEventListener !== 'undefined') {
            window.addEventListener('message', handleMessage, false)
          } else if (typeof window.attachEvent !== 'undefined') {
            window.attachEvent('onmessage', handleMessage)
          }
        } catch (error) {
          console.log(error)
        }
      }
    }

    onMounted(() => {
      createQrCode()
    })

    return {
      toLogin,
      createQrCode
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
